import { GridSummaryWebComponent } from './component/GridSummaryWebComponent';

export { GridSummaryWebComponent };
